import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import SchoolCardStatic from "../schoolCard/SchoolCardStatic";
import T from "../translations/Translations";

import "../../styles/SelectedSchools.scss";

const SelectedSchools = ({
    formDispatch,
    formState,
    handleSubmit,
    isMutable,
    oeStudentInfo,
    parentOffer,
    schoolFinalize
}) => {
    const { schoolChoiceDetailDtos } = formState;

    const [blockOneSchools, setBlockOneSchools] = useState([]);
    const [blockTwoSchools, setBlockTwoSchools] = useState([]);

    const selectedSchoolsBody = T({ key: "OE_Schools_Selected_Schools_Body" });
    const selectedSchoolsBodyWaitlist = T({ key: "OE_Schools_Selected_Schools_Body_2" });
    const selectedSchoolsNone = T({ key: "OE_Schools_Selected_Schools_None" });

    useEffect(() => {
        if (schoolChoiceDetailDtos && schoolChoiceDetailDtos.length > 0) {
            const match = schoolChoiceDetailDtos.filter((obj) =>
                ["ACCEPT_OFFER", "DENY_OFFER", "MAKE_OFFER"].includes(obj.status)
            );
            const match2 = schoolChoiceDetailDtos.filter(
                (obj) => !["ACCEPT_OFFER", "DENY_OFFER", "MAKE_OFFER"].includes(obj.status)
            );
            if (match && match?.length > 0) {
                setBlockOneSchools(match);
            }
            if (match2 && match2.length > 0) {
                setBlockTwoSchools(match2);
            }
        }
    }, [schoolChoiceDetailDtos]);

    return (
        <section className="selected-schools-container-static">
            <h5 className="dark-blue-text">{T({ key: "OE_Schools_My_Schools_Title" })}</h5>
            <p className="dark-blue-text">{T({ key: "OE_Schools_Selected_Schools_Header" })}</p>
            {parentOffer ? (
                <div className="selected-schools-blocks-container">
                    {blockOneSchools && blockOneSchools.length > 0 && (
                        <div className="selected-schools-blocks">
                            <div className="block-text">{selectedSchoolsBody}</div>
                            <div className="block-school">
                                {blockOneSchools &&
                                    blockOneSchools.map((school, index) => {
                                        const uniqueKey = `selected-school-static-${index}`;
                                        return (
                                            <SchoolCardStatic
                                                formDispatch={formDispatch}
                                                formState={formState}
                                                handleSubmit={handleSubmit}
                                                isMutable={isMutable}
                                                key={uniqueKey}
                                                oeStudentInfo={oeStudentInfo}
                                                parentOffer={parentOffer}
                                                school={school}
                                            />
                                        );
                                    })}
                            </div>
                        </div>
                    )}
                    {blockTwoSchools && blockTwoSchools.length > 0 && (
                        <div className="selected-schools-blocks">
                            <div className="block-text">{selectedSchoolsBodyWaitlist}</div>
                            <div className="block-school">
                                {blockTwoSchools.map((school, index) => {
                                    const uniqueKey = `selected-school-static-${index}`;
                                    return (
                                        <SchoolCardStatic
                                            formDispatch={formDispatch}
                                            formState={formState}
                                            key={uniqueKey}
                                            oeStudentInfo={oeStudentInfo}
                                            parentOffer={parentOffer}
                                            school={school}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {!blockOneSchools.length > 0 && !blockTwoSchools.length > 0 && <h2>{selectedSchoolsNone}</h2>}
                </div>
            ) : (
                <div className="selected-schools-block">
                    {schoolChoiceDetailDtos && schoolChoiceDetailDtos.length > 0 ? (
                        schoolChoiceDetailDtos.map((school, index) => {
                            const uniqueKey = `selected-school-static-${index}`;
                            return (
                                <SchoolCardStatic
                                    formDispatch={formDispatch}
                                    formState={formState}
                                    key={uniqueKey}
                                    oeStudentInfo={oeStudentInfo}
                                    school={school}
                                    schoolFinalize={schoolFinalize}
                                />
                            );
                        })
                    ) : (
                        <h2>{selectedSchoolsNone}</h2>
                    )}
                </div>
            )}
        </section>
    );
};

SelectedSchools.propTypes = {
    formDispatch: PropTypes.func.isRequired,
    formState: PropTypes.oneOfType([PropTypes.object]).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isMutable: PropTypes.bool,
    oeStudentInfo: PropTypes.oneOfType([PropTypes.object]).isRequired,
    parentOffer: PropTypes.oneOfType([PropTypes.object]),
    schoolFinalize: PropTypes.oneOfType([PropTypes.object])
};

SelectedSchools.defaultProps = {
    isMutable: true,
    parentOffer: null,
    schoolFinalize: null
};

export default SelectedSchools;
